export type CustomAttributes = {
    CIA_enabled_contact: string;
    CIA_enabled_company: string;
};

export const attributesIsCIAFlags = (attributes: unknown): attributes is CustomAttributes => {
    if (!attributes || typeof attributes !== "object") {
        return false;
    }

    return (
        typeof (attributes as CustomAttributes).CIA_enabled_contact === "string" &&
        typeof (attributes as CustomAttributes).CIA_enabled_company === "string"
    );
};
